import Axios from "axios";
import { hideLoading, showAlert, showLoading } from "../Actions/GeneralActions";
import { getHeaders } from "../../utills";
import Apis from "../../config/APIs";
import { addDiscountCode, delDiscountCode, delSupportQuery, getDiscountCodesData, getQueriesData, getWebQueriesData } from "../Actions/PagesAction";

export const PagesMiddleware = {

    createPage: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const routename = params?.key == "terms" ? Apis.terms : params?.key == "privacy" ? Apis.privacy : Apis.about;
                    const { data } = await Axios.post(routename, { description: params?.description }, await getHeaders());

                    if (data?.success) {
                        resolve(data?.data);
                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "create page of" + params?.key,
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    updatePage: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const routename = params?.key == "terms" ? Apis.terms : params?.key == "privacy" ? Apis.privacy : Apis.about;
                    const { data } = await Axios.patch(routename, { description: params?.description, id: params?.id }, await getHeaders());

                    if (data?.success) {
                        resolve(data?.data);
                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "update page of " + params?.key,
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    getPage: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const routename = params?.key == "terms" ? Apis.terms : params?.key == "privacy" ? Apis.privacy : Apis.about;
                    const { data } = await Axios.get(routename, await getHeaders());

                    if (data?.success) {
                        resolve(data?.data);
                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "get page of " + params?.key,
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    getQueries: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const query = new URLSearchParams();
                    query.append('limit', params.limit);
                    query.append('page', params.page);
                    const { data } = await Axios.get(Apis.get_queries(query.toString()), await getHeaders());

                    if (data?.success) {
                        resolve(true);
                        dispatch(getQueriesData(data?.data));
                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "get support queries ",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    delQuery: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const query = new URLSearchParams();
                    query.append('id', params.id);

                    const { data } = await Axios.delete(Apis.get_queries(query.toString()), await getHeaders());

                    if (data?.success) {
                        resolve(true);
                        dispatch(delSupportQuery(params.id))
                        dispatch(showAlert({ type: "success", message: data?.message }));
                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "del support query ",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    createFAQ: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const { data } = await Axios.post(Apis.faqs(), params, await getHeaders());

                    if (data?.success) {
                        resolve(data?.data);
                        dispatch(showAlert({ type: "success", message: data?.message }));

                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "create faq ",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    getFAQ: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const query = new URLSearchParams();
                    const { data } = await Axios.get(Apis.faqs(), await getHeaders());

                    if (data?.success) {
                        resolve(data?.data);
                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "get faqs ",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    deleteFAQ: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const query = new URLSearchParams();
                    query.append('id', params.id);
                    const { data } = await Axios.delete(Apis.faqs(query.toString()), await getHeaders());

                    if (data?.success) {
                        resolve(data?.data);
                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "get faqs ",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    createDiscountCode: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const { data } = await Axios.post(Apis.discount_code(), params, await getHeaders());

                    if (data?.success) {
                        dispatch(addDiscountCode(data?.data))
                        resolve(true);
                        dispatch(showAlert({ type: "success", message: data?.message }));

                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "create discount code ",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    getDiscountCodes: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const query = new URLSearchParams();
                    query.append('limit', params.limit);
                    query.append('page', params.page);

                    const { data } = await Axios.get(Apis.discount_code(query.toString()), await getHeaders());

                    if (data?.success) {
                        resolve(true);
                        dispatch(getDiscountCodesData(data?.data));
                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "get discount codes ",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    onDelDiscountCode: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {

                    const query = new URLSearchParams();
                    query.append('id', params.id);
                    const { data } = await Axios.delete(Apis.discount_code(query.toString()), await getHeaders());

                    if (data?.success) {
                        resolve(data?.data?.data);
                        dispatch(delDiscountCode(params.id));
                        dispatch(showAlert({ type: "success", message: data?.message }));
                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "del discount code ",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    createAdsPricing: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const { data } = await Axios.put(Apis.ads_pricing, params, await getHeaders());

                    if (data?.success) {
                        resolve(true);
                        dispatch(showAlert({ type: "success", message: data?.message }));

                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "create ads pricing ",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    getAdsPricing: () => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const { data } = await Axios.get(Apis.ads_pricing, await getHeaders());

                    if (data?.success) {
                        resolve(data?.data);

                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "get ads pricing ",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    onResetPassword: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const { data } = await Axios.patch(Apis.reset_password, params, await getHeaders());

                    if (data?.success) {
                        resolve(true);
                        dispatch(showAlert({ type: "success", message: data?.message }));

                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "reset password",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },

    getWebQueries: (params) => {
        return (dispatch) => {
            dispatch(showLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const query = new URLSearchParams();
                    query.append('limit', params.limit);
                    query.append('page', params.page);
                    const { data } = await Axios.get(Apis.get_web_queries(query.toString()), await getHeaders());

                    if (data?.success) {
                        resolve(true);
                        dispatch(getWebQueriesData(data?.data));
                    } else {
                        reject(data?.data);
                        dispatch(showAlert({ type: "error", message: data?.message }));
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: "get web queries ",
                            message: error?.response?.data?.message
                                ? error?.response?.data?.message
                                : error.message,
                            type: "Error",
                            status: error?.response?.status,
                        })
                    );
                }
                finally {
                    dispatch(hideLoading());
                }
            });
        };
    },



};
